export default "/images/brand5.jpg?b74fed2c69cf70493d1022506a5e2c8e";